module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-31-6623683781e997bd131afab331470fcc.png";